/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, {css} from "styled-components";
import Colors from "constants/Colors";
import PropTypes from "prop-types";
import {FontWeight, QuicksandBold} from "components/Text";
import {FiraSansBold, FiraSansExtraLight} from "components/Text/Text";
import {Breakpoints} from "../../../../constants/Breakpoints";
import { mediaHelperMaxWidth } from "../../../../utils/src";

const propTypes = {
  isActive: PropTypes.bool,
  newBorder: PropTypes.bool,
};

const defaultProps = {
  isActive: false,
  newBorder: false,
};

const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;


  ${mediaHelperMaxWidth.sm`
    flex-direction: column;
    align-items: center;
  `}

`;

const ButtonContainerRow = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;


  ${mediaHelperMaxWidth.sm`
    flex-direction: column;
    align-items: center;
  `}

`;

const ButtonContent = styled.div`
  display:flex;
  flex-direction:auto;
  justify-content:space-evenly;
  background-color:#FFF;
  
  ${mediaHelperMaxWidth.sm`
    margin-top: 10px;
    width: 100%
  `}
`;


const ViewText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
  
  
  ${mediaHelperMaxWidth.md`
      justify-content: flex-start;
  `}
`;

const DialogConfirm = styled.button`
  width: 100%;
  height: 40px;
  background: ${Colors.BLUE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;

const DialogRejected = styled.button`
  width: 100%;
  height: 40px;
  background: ${Colors.GRAY[6]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

const TextArea2 = styled.textarea`
  width:100%;
  height: 120px;
  padding:15px;
  border:2px solid ${Colors.GRAY[3]};
  border-radius:8px;
  resize:none;
  font-family: Courier, monospace;
  font-weight: ${FontWeight.SemiBold};
  color: ${Colors.GRAY[6]};
  font-size:14px;
`;

const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;


const ContentTextarea = styled.div`
  width: 100%;  
  
  p {
    color: ${Colors.GRAY[0]};
    margin-bottom: 5px;
    margin-top: 10px;
    font-weight: 800;
    font-size: 14px; 
  }
`;



export {
  ButtonContainer,
  ButtonContent,
  ViewText,
  DialogConfirm,
  TextArea2,
  DialogCancel,
  DialogRejected,
  ContentTextarea,
  ButtonContainerRow
};
